import Swiper from 'swiper';

const moduleName = 'benefits';

export function benefits() {

    Array.from(document.querySelectorAll('.js-benefits')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const BREAKPOINT = 1024;

        const benefits = self;
        const benefitsSlider = benefits.querySelector('.js-benefits-slider');
        const benefitsSliderWrapper = benefits.querySelector('.js-benefits-slider-wrapper');
        const benefitsItems = benefits.querySelectorAll('.js-benefits-item');
        const benefitsPagination = benefits.querySelector('.js-benefits-pagination');
        const benefitsSwiperOptions = {
            simulateTouch: false,
            slideActiveClass: '_active',
            autoHeight: true,
            pagination: {
                el: benefitsPagination,
                bulletClass: 'pagination__bullet',
                bulletActiveClass: '_active',
                clickable: true
            }
        };
        let benefitsSwiper;

        initBenefitsSwiper();

        window.addEventListener('resize', initBenefitsSwiper);



        function initBenefitsSwiper() {
            if (document.body.clientWidth < BREAKPOINT && typeof benefitsSwiper != 'object') {
                benefitsSlider.classList.add('swiper-container');
                benefitsSliderWrapper.classList.add('swiper-wrapper');
                Array.from(benefitsItems).forEach((benefitsItem) => benefitsItem.classList.add('swiper-slide'));

                benefitsSwiper = new Swiper(benefitsSlider, benefitsSwiperOptions);
            } else if (document.body.clientWidth >= BREAKPOINT && typeof benefitsSwiper == 'object') {
                benefitsSwiper.destroy();
                benefitsSlider.classList.remove('swiper-container');
                benefitsSliderWrapper.classList.remove('swiper-wrapper');

                Array.from(benefitsItems).forEach((benefitsItem, index) => {
                    benefitsItem.classList.remove('swiper-slide');
                });

                benefitsSwiper = undefined;
            }
        }
    });

}